import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: 'デバイス',
  
  // model
  deviceModel: []
}

const getters = {
  get: state => state
}

const actions = {
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {deviceParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['device'],
        ['v1DeviceListGet'],
        [deviceParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setDeviceModel', res[0].data.deviceTypes)
            console.log('deviceModel', state.deviceModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
}

const mutations = {
  // model
  setDeviceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'deviceModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
